// externals
import { type FC } from 'react';
import { useSelector } from 'react-redux';

// libraries
import * as tradeInsSelectors from '@makemydeal/dr-dash-store/selectors/tradeIns';
import { useTradeReconCost } from '@makemydeal/dr-dash-store/hooks/useTradeReconCost';
import type { TradeReconCostCardProps } from '@makemydeal/dr-dash-store/types/tradeReconCostTypes';
import { TradeReconSingleTrade } from '../TradeReconSingleTrade/TradeReconSingleTrade';
import { CardContainer as Container } from '../tradeReconCost.styles';
import type { SingleTradeInItem } from '@makemydeal/dr-dash-store/types/tradeInTypes';

/* istanbul ignore next - default parameter branch */
export const TradeReconCostCard: FC<TradeReconCostCardProps> = ({
    isReconCostDirtyRef: _isReconCostDirtyRef,
    isInsideSlideOut: _isInsideSlideOut,
    shouldTriggerValidation: _shouldTriggerValidation,
    ...props
}) => {
    const tradeIns = useSelector(tradeInsSelectors.getAllTradeIns);
    const {
        tradeData,
        reconItemOptions,
        handleValuationChange,
        handleReconItemNameChange,
        handleReconItemAmountChange,
        handleAddReconItem,
        handleRemoveReconItem
    } = useTradeReconCost({ tradeIns: tradeIns || [] });

    return (
        <Container {...props}>
            {(tradeIns || []).map((trade: SingleTradeInItem, index: number) => {
                const tradeKey = `trade-${index + 1}`;
                const data = tradeData[tradeKey] || {
                    value: 0,
                    acv: 0,
                    amountOwed: 0,
                    tradeReconditionItems: [],
                    tradeReconditionTotal: 0
                };

                return (
                    <TradeReconSingleTrade
                        key={tradeKey}
                        tradeKey={tradeKey}
                        tradeIndex={index}
                        trade={trade}
                        data={data}
                        isLastTrade={index === (tradeIns || []).length - 1}
                        reconItemOptions={reconItemOptions}
                        onValuationChange={handleValuationChange}
                        onReconItemNameChange={handleReconItemNameChange}
                        onReconItemAmountChange={handleReconItemAmountChange}
                        onAddReconItem={handleAddReconItem}
                        onRemoveReconItem={handleRemoveReconItem}
                    />
                );
            })}
        </Container>
    );
};
